/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { ceil, random } from 'lodash';

const generateKey = () => Date.now() + ceil(random() * 1000);

const baseMeasure = {
  key: generateKey(),
  MeasureName: 'Measure 1',
  isExpand: true,
  tags: [],
};

const baseMetric = {
  expressionType: 'SQL',
  isNew: false,
  hasCustomLabel: true,
  label: 'Measure 1',
};

const defaultMeasureValue = [
  {
    ...baseMeasure,
    isValid: true,
    SelectControlColumn: 'events',
    SelectControlAggregator: 'COUNT',
    hasChanged: true,
    metric: {
      ...baseMetric,
      sqlExpression: 'COUNT(1)',
      column: { column_name: '1' },
      aggregate: 'COUNT',
      optionName: 'metric_zfdbv4iioe8_qfvjd0ujka',
    },
  },
];

const defaultCalculatedMeasureValue = [
  {
    ...baseMeasure,
    isValidExpression: false,
    sqlExpression: '',
    measure_ids: [],
    calculatedMeasures: [],
    isCalculatedMeasure: true,
    calMeasureVersion: 2,
    calculatedMeasureLogic: '',
    validationErrors: 'Expression cannot be empty',
    metric: {
      ...baseMetric,
      sqlExpression: '',
      column: { column_name: 'calculated' },
    },
  },
];

export const getDefaultMeasureValue = (vizType = 'measure') =>
  vizType === 'calculated_measure'
    ? defaultCalculatedMeasureValue
    : defaultMeasureValue;
